<template>
  <div>
    <div class="enter">
      <!-- 1.信电查入口 -->
      <div class="right">
        <!-- <img
          style="height: 320px; width: 100%; overflow: hidden"
          src="../../assets/xdcBgc.jpg"
          alt=""
        /> -->
        <iframe
          style="height: 800px; width: 100%; margin-top: -200px"
          src="https://www.cecdlzx.com/dlzx/#/electric"
          frameborder="0"
        ></iframe>
      </div>
    </div>
    <!-- 导航 -->
    <navigate style="margin-top: 50px" :daohangshuju="daohangshuju" />

    <div class="text1 contentCss">
      <p>
        信电查是中电联征信从行业监管出发，依托行业征信优势，整合市场化大数据资源并以电力行业专有数据为特色，提供企业信息、企业发展、司法风险、经营风险、经营状况、知识产权、电力行业风险、行业认证等多种数据维度查询。面向社会推出的商业信息查询及分析服务。
      </p>
      <p>
        为涉电力领域市场主体，包括政府机构、银行、证券、会计事务所、律所、媒体、企业等，提供全面商业信息调查、线索发现、幕后关联、风险预警等系统性企业级解决方案。

        <el-link
          type="primary"
          :underline="false"
          href="https://www.cecdlzx.com/dlzx/#/electric"
          target="_blank"
          ><span class="licxCss">立即查询>></span></el-link
        >
      </p>
    </div>
    <div class="product contentCss">
      <div class="text">
        <h4>主要功能</h4>
        <p>实现更快捷、全面、易懂的商务信息查询。</p>
        <p>企业级风险预警及分析服务一体化Saas平台。</p>
      </div>
      <div class="text">
        <h4>行业特色</h4>
        <p>
          具有电力行业特色数据的综合信息查询平台，不仅包含工商信息、股东信息、实际控制权、知识产权、司法风险、经营风险商业数据维度，同时结合了电力项目中标信息等电力征信独有数据，用电信息、电力科技创新奖、行业评价、重点关注名单等，实现了全维度覆盖。
        </p>
        <p>
          信电查将逐步升级迭代，实现商务资讯“五找”<span style="font-weight: 700"
            >——找客户、找资金、找项目、找服务、找产品。</span
          >
        </p>
      </div>
      <div class="text">
        <h4>服务优势</h4>
        <p>
          会员查询不限次、报告免费下载、数据批量导出、风险提示预设。具有纵览企业画像、洞察企业商业链路、法律讼背调、查询热点公司、助力商业决策、规避合作风险等功能。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import xdcPng from '@/assets/xdc.png'
import ckPng from '@/assets/logo.png'
import srcImg from '@/assets/xdc1.png'
import HoverImage from "@/components/HoverImage/index"
// 导航组件
import navigate from '@/components/navigate'
export default {
  name: 'vuecomponent',
  components: {
    HoverImage,
    navigate
  },
  data () {
    return {
      xdcPng: xdcPng,
      ckPng,
      searchInput: '',
      bannerList: [
        {
          id: 1,
          content: 'https://www.cecdlzx.com/oss/owms/26E5A26B9230CD01A4B1A1C44EC225BD/257f8ab88f9445b98f9c2826c3203e45.png',
          url: "https://www.cecdlzx.com/owms/#/home"
        },
        {
          id: 2,
          content: 'https://www.cecdlzx.com/oss/owms/26E5A26B9230CD01A4B1A1C44EC225BD/576e0a8c10f1459797aced9ca904efd1.png',
          url: "https://www.cecdlzx.com/dlzx/#/electric"
        },
        {
          id: 3,
          content: 'https://www.cecdlzx.com/oss/owms/26E5A26B9230CD01A4B1A1C44EC225BD/77b7d0be5ebc43ad94854b7863386d4c.png',
          url: "https://www.cecdlzx.com/dlzx/#/login"
        },
      ],
      key: "value",
      srcImg,
      daohangshuju: '信电查',
    }
  },

}
</script>

<style lang="less" scoped>
.bannerImg {
  height: 260px;
}

.text1 {
  padding: 0 10px;
}
.product {
  margin-bottom: 60px;
  .h3Text {
    font-size: 24px;
    font-weight: 400;
    text-align: center;
    color: rgba(58, 58, 74, 1);
    margin-top: 30px;
  }
  .text {
    // margin: 15px;
    padding: 10px;
    h4 {
      color: #005ba3;
      margin-top: 10px;
      margin-bottom: 10px;
      font-size: 16px;
    }
    p {
      margin: 0 0 5px;
      line-height: 24px;
    }
  }
}

.partner {
  // margin: 10px 0;

  .title {
    text-align: center;
    position: relative;

    p {
      font-size: 48px;
      font-weight: bold;
      color: rgba(153, 154, 155, 0.3);
    }

    h2 {
      font-size: 36px;
      position: absolute;
      margin: 0;
      left: 45%;
      top: 35px;
    }
  }

  .list {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
    align-items: center;

    span {
      width: 150px;
      height: 60px;
    }
  }
}

.enter {
  overflow: hidden;
  position: relative;
  // padding: 10px;
  width: 100%;
  height: 350px;
  .right {
    width: 100%;
  }
  .last {
    margin-left: 80px;
    width: 100%;
    position: absolute;
    top: 260px;
    .smallBox {
      font-size: 16px;
      width: 180px;
      height: 50px;
      color: #fff;
      border-radius: 5px;
      padding: 10px;
      text-align: center;
      line-height: 45px;
      height: 60px;
      border: 2px solid #53aee7;
      background: #53aee7;
      box-shadow: 0 1px 1px #53aee7, 0 2px 2px #53aee7, 0 3px 3px #53aee7,
        0 4px 4px #53aee7, 0 5px 5px #53aee7;
      transform-origin: 50% 50%;
      /* 设置过渡动画 */
      transition: all 1s;
    }
  }
}
.smallBox:hover {
  /* 鼠标移动上去后  */
  transform: scale(1.2, 1.2);
}
.xdcSearch {
  margin: 10px auto;
  height: 45px;
  line-height: 45px;
  border-radius: 5px;
  text-align: center;
  border: 1px solid #53aee7;
  width: 150px;
}
</style>
